import apiService from '@/utils/api-client'

export default {
  // eslint-disable-next-line no-unused-vars
  async getTransactionTreePaths({ commit }, { maxDepth, directionUp, address, tx_hash, token, rootTx, leafTx }) {
    try {
      return await apiService.get('/report/txs-tree/paths', {
        params: {
          maxDepth,
          directionUp,
          address,
          tx_hash,
          token,
          rootTx,
          leafTx,
          $project: { timestamp: 1, address: 1 }
        }
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getTxIntersections({ commit }, { skipAddresses, limit = 100, rightTx, leftTx }) {
    try {
      return await apiService.get('/explorer/addressIntersections', {
        params: {
          skipAddresses,
          limit,
          rightTx,
          leftTx
        }
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
